import { salesSlice } from './slice'

// Get All
export const { setMySalesLoading } = salesSlice.actions
export const { setMySalesList } = salesSlice.actions
export const { setMySalesError } = salesSlice.actions
export const { resetMySalesList } = salesSlice.actions
export const { setMySalesSelected } = salesSlice.actions
export const { setMySalesFiltered } = salesSlice.actions
export const { setMySalesFilterText } = salesSlice.actions
// Get Sale Details
export const { setSaleDetailsLoading } = salesSlice.actions
export const { setSaleDetailsData } = salesSlice.actions
export const { setSaleDetailsError } = salesSlice.actions
export const { resetSaleDetails } = salesSlice.actions
// Send Documents
export const { setSaleSendDocumentLoading } = salesSlice.actions
export const { setSaleSendDocumentSuccess } = salesSlice.actions
export const { setSaleSendDocumentError } = salesSlice.actions
export const { resetSaleSendDocuments } = salesSlice.actions
// Delete Documents
export const { setSaleDeleteDocumentLoading } = salesSlice.actions
export const { setSaleDeleteDocumentSuccess } = salesSlice.actions
export const { setSaleDeleteDocumentError } = salesSlice.actions
export const { resetSaleDeleteDocuments } = salesSlice.actions
